var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInboxUnread = function SvgInboxUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M14.667 10.016c0 2.54-1.333 3.81-4 3.81h-.333a.688.688 0 0 0-.533.253l-1 1.27c-.44.559-1.16.559-1.6 0l-1-1.27a.767.767 0 0 0-.534-.254h-.333c-2.667 0-4-.634-4-3.81V6.842c0-2.54 1.333-3.81 4-3.81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.664 8.746h.006M7.998 8.746h.006M5.33 8.746h.006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12 7.095c1.768 0 3.2-1.364 3.2-3.047C15.2 2.364 13.769 1 12 1c-1.767 0-3.2 1.364-3.2 3.048 0 1.683 1.433 3.047 3.2 3.047Z"
  })));
};
export default SvgInboxUnread;